import { RootState } from '../store';

// Form data selectors
export const selectFormData = (state: RootState) => state.investmentFormReducer.formData;
export const selectFunderId = (state: RootState) => state.investmentFormReducer.formData.funder_id;
export const selectRawFunderId = (state: RootState) => state.investmentFormReducer.formData.raw_funder_id;
export const selectPrincipalAmount = (state: RootState) => state.investmentFormReducer.formData.principal_amount;
export const selectAmountToCredit = (state: RootState) => state.investmentFormReducer.formData.amount_to_credit;
export const selectInterestRate = (state: RootState) => state.investmentFormReducer.formData.interest_rate;
export const selectTenure = (state: RootState) => state.investmentFormReducer.formData.tenure;
export const selectCurrency = (state: RootState) => state.investmentFormReducer.formData.currency;
export const selectInterestRepaymentType = (state: RootState) => state.investmentFormReducer.formData.interest_repayment_type;
export const selectNumberOfDaysInYear = (state: RootState) => state.investmentFormReducer.formData.number_of_days_in_year;
export const selectEffectiveDate = (state: RootState) => state.investmentFormReducer.formData.effective_date;
export const selectTransactionReceiptFromForm = (state: RootState) => ({
  base64: state.investmentFormReducer.formData.transactionReceiptBase64,
  fileName: state.investmentFormReducer.formData.transactionReceiptName,
});
export const selectWalletId = (state: RootState) => state.investmentFormReducer.formData.wallet_id;

// Wallet balance selectors
export const selectWalletBalance = (state: RootState) => state.investmentFormReducer.walletBalance;
export const selectIsWalletBalanceLoading = (state: RootState) => state.investmentFormReducer.isWalletBalanceLoading;
export const selectWalletBalanceError = (state: RootState) => state.investmentFormReducer.walletBalanceError;

// Step management selectors
export const selectCurrentStep = (state: RootState) => state.investmentFormReducer.currentStep;

// Interest calculation selectors
export const selectCalculatedInterest = (state: RootState) => state.investmentFormReducer.calculatedInterest;
export const selectIsCalculatingInterest = (state: RootState) => state.investmentFormReducer.isCalculatingInterest;
export const selectCalculateInterestError = (state: RootState) => state.investmentFormReducer.calculateInterestError;

// Transaction receipt selector
export const selectTransactionReceipt = (state: RootState) => state.investmentFormReducer.transactionReceipt;

// Breakdown modal selector
export const selectShowBreakdownModal = (state: RootState) => state.investmentFormReducer.showBreakdownModal;

// Selected investor selector
export const selectSelectedInvestor = (state: RootState) => state.investmentFormReducer.selectedInvestor;

// Loading selector
export const selectIsLoading = (state: RootState) => state.investmentFormReducer.isLoading;

// Available wallets selector
export const selectAvailableWallets = (state: RootState) => state.investmentFormReducer.availableWallets;